package kz.dentalcrm.app.screens.services.services.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.Selectable
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

data class ServicesState(
    val search: String = "",
    val services: PersistentList<ServiceItem> = persistentListOf(),
    val serviceCategories: PersistentList<Selectable<ServiceCategory>> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
        data object Idle : ScreenState
    }
}
